import { defineStore } from 'pinia'
import { v4 } from 'uuid'
import type { DefineComponent, VNode } from 'vue'

type Component = VNode | DefineComponent<any, any, any, any, any>

interface ToastData {
  // 若有手動傳入 id，相同 id 的 toast 不會同時顯示多次
  id: string | number
  type: 'warn' | 'info' | 'success'
  iconName: 'Check_Circle' | 'Checked' | 'PersonBadge_fill' | 'Warning'
  message?: string
  messageElement?: Component
  title?: string
  titleElement?: Component
  hideBtnClose?: boolean
  hasHeader?: boolean
  isShow: boolean
  delay?: number
}

export const useToastStore = defineStore('toast', () => {
  const toastList = ref<ToastData[]>([])

  let identityList: (number | string)[] = []

  const showToast = (
    data: Omit<ToastData, 'id' | 'isShow'> & { id?: string | number }
  ) => {
    if (data.id != null && identityList.includes(data.id)) {
      return
    }

    const toastData = {
      ...data,
      isShow: true,
      id: data.id ?? v4()
    }

    toastList.value.push(toastData)

    identityList = toastList.value
      .map(({ id }) => id)
      .filter((item): item is string | number => !!item)

    setTimeout(() => {
      hideToast(toastData.id)
    }, data.delay ?? 3000)
  }

  const hideToast = (id: string | number) => {
    const index = toastList.value.findIndex((alert) => alert.id === id)

    const toastData = toastList.value[index]

    if (toastData) {
      toastData.isShow = false
    }

    setTimeout(() => {
      removeToast(id)
    }, 1000)
  }

  const removeToast = (id: string | number) => {
    const index = toastList.value.findIndex((alert) => alert.id === id)

    if (index !== -1) {
      toastList.value = [
        ...toastList.value.slice(0, index),
        ...toastList.value.slice(index + 1)
      ]
    }
  }

  return { toastList, showToast, hideToast }
})
